import { getTestIdAttribute } from './get-test-id-attribute/get-test-id-attribute';

export default {
  getTestIdAttribute,
};
